/* eslint-disable no-unused-vars */
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { isIOption } from '../../../../../../../commons/types/commonTypes';
import { Wrapper } from './FNSTable.Styles';
var columns = [
    {
        field: 'name',
        headerName: 'Name',
        flex: 1
    },
    {
        field: 'value',
        headerName: 'Value',
        flex: 1
    },
];
export var FNSTable = function (_a) {
    var data = _a.data;
    var rows = [
        {
            id: '1',
            name: 'Contact Filters',
            value: (data === null || data === void 0 ? void 0 : data.contactFilters.map(function (data) { return (isIOption(data) ? data.label : data); }).toString()) || '-'
        },
        {
            id: '2',
            name: 'Phone Filters',
            value: (data === null || data === void 0 ? void 0 : data.phoneFilters.map(function (data) { return (isIOption(data) ? data.label : data); }).toString()) || '-'
        },
        {
            id: '3',
            name: 'Contact Sorting',
            value: (data === null || data === void 0 ? void 0 : data.contactSorting.map(function (data) { return (isIOption(data) ? data.label : data); }).toString()) || '-'
        },
    ];
    return (React.createElement(Wrapper, null,
        React.createElement(DataGrid, { rows: rows, columns: columns, pageSize: 5, rowsPerPageOptions: [5], hideFooter: true, autoHeight: true, density: 'compact' })));
};
FNSTable.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=FNSTable.js.map